/**
 * Single source of truth for brand colors, copy and small constants used
 * across the landing site + admin. Update these instead of hunting through files.
 *
 * RULES (read CONTRIBUTING.md before editing):
 *   - Color values map to Tailwind utility classes used in components. Do not
 *     change individual color literals in components; update here or extend
 *     tailwind.config.js with a new semantic name.
 *   - Keep this file dependency-free (no imports from /components).
 */

export const COLORS = Object.freeze({
  navy: "#0A1930",
  navyDeep: "#0F2348",
  action: "#0066CC",
  actionHover: "#0055AA",
  flagRed: "#C8102E",
  surface: "#F5F5F7",
  surfaceCool: "#F4F6FB",
});

export const FALLBACK_SMS = Object.freeze({
  number: "+13853547742",
  display: "(385) 354-7742",
});

export const BRANCHES = Object.freeze([
  "U.S. Army",
  "U.S. Navy",
  "U.S. Marine Corps",
  "U.S. Air Force",
  "U.S. Coast Guard",
  "U.S. Space Force",
]);

/**
 * Intro animation config — single source of truth shared between
 * <BirdFlightIntro /> and <Hero />.
 *
 * To tune the entrance:
 *   - enabled: global kill switch
 *   - replayMode: 'always' = every full page load, 'session-once' = first visit per browser tab
 *   - desktopDurationSec / mobileDurationSec: total flight time
 *   - heroSyncOffsetSec: how many seconds BEFORE the bird touches down the hero
 *       starts revealing. Tiny positive number = nicely overlapped cascade.
 */
export const INTRO = Object.freeze({
  enabled: true,
  replayMode: "always",
  desktopDurationSec: 1.9,
  mobileDurationSec: 1.4,
  heroSyncOffsetSec: 0.25,
});
